import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
const Privacy: React.FC = () => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    fetch('/Content/PrivacyContent.md')
      .then((res) => res.text())
      .then((data) => setHtml(data));
  }, []);
  return (
    <div className="policy">
      <ReactMarkdown>{html}</ReactMarkdown>
    </div>
  );
};

export default Privacy;
